var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"input-container"},[_c('input',{attrs:{"type":"tel","maxlength":"6"},domProps:{"value":_vm.messageCode},on:{"input":_vm.changeVal}}),_c('div',{staticClass:"devider"})])])}
var staticRenderFns = []

export { render, staticRenderFns }